import { useState } from "react";
import queryKeys from "../configs/react-query/query-key";
import { LOCAL_STORAGE } from "../constants/index";
import { useMutationData } from "./useMutationData";

export const useUserInfo = () => {
  const userId = localStorage.getItem(LOCAL_STORAGE.USER_ID);
  const [userName, setUserName] = useState("");
  const [userDepartment, setUserDepartment] = useState("");

  const getUserData = useMutationData(
    `${queryKeys.getUserDataByUserId}/${userId}`,
    { method: "GET" },
    {
      onSuccess: (response) => {
        if (typeof response !== "string") {
          setUserName(response.userName);
          setUserDepartment(response.deptCdName);
        }
      },
      onError: (error) => console.error("Error fetching user data:", error),
    },
  );

  return { userId, userName, userDepartment, getUserData };
};
